<template>
  <b-row class="match-height">
    <b-col lg="12">
      <tab-programmatically />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import TabProgrammatically from './TabProgrammatically.vue'

export default {
  components: {
    BRow,
    BCol,
    TabProgrammatically,
  },
}
</script>
